import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();

  return (
    <nav className="bg-white/90 backdrop-blur-md border-b border-neutral-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo/Brand */}
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center">
              <div className="w-9 h-9 bg-gradient-to-br from-accent-500 to-accent-600 rounded-xl flex items-center justify-center mr-3 shadow-soft">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>
                </svg>
              </div>
              <span className="text-xl font-bold text-neutral-900">Tinnitus Tracker</span>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-1">
              <Link
                to="/"
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  location.pathname === '/'
                    ? 'bg-primary-500 text-white shadow-soft'
                    : 'text-neutral-600 hover:text-primary-600 hover:bg-neutral-100'
                }`}
              >
                App Support
              </Link>
              <Link
                to="/privacy"
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  location.pathname === '/privacy'
                    ? 'bg-primary-500 text-white shadow-soft'
                    : 'text-neutral-600 hover:text-primary-600 hover:bg-neutral-100'
                }`}
              >
                Privacy Policy
              </Link>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-lg text-neutral-500 hover:text-neutral-700 hover:bg-neutral-100 focus:outline-none focus:ring-2 focus:ring-primary-500"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className="md:hidden" id="mobile-menu">
        <div className="px-4 pt-2 pb-3 space-y-1 border-t border-neutral-200 bg-white/95 backdrop-blur-md">
          <Link
            to="/"
            className={`block px-3 py-2 rounded-lg text-base font-medium transition-all duration-200 ${
              location.pathname === '/'
                ? 'bg-primary-500 text-white'
                : 'text-neutral-600 hover:text-primary-600 hover:bg-neutral-100'
            }`}
          >
            App Support
          </Link>
          <Link
            to="/privacy"
            className={`block px-3 py-2 rounded-lg text-base font-medium transition-all duration-200 ${
              location.pathname === '/privacy'
                ? 'bg-primary-500 text-white'
                : 'text-neutral-600 hover:text-primary-600 hover:bg-neutral-100'
            }`}
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;